import type { AccountInfo } from "@azure/msal-browser";

import { DEMO_COMPANY_HOLDINGS_AG, DEMO_USER_ID, DEMO_USER_USERNAME } from "./seed/identifiers.ts";

export const DEMO_USER = {
  localAccountId: DEMO_USER_ID,
  username: DEMO_USER_USERNAME,
  firstName: "Anna",
  lastName: "Schmidt",
  fullName: "Anna Schmidt",
  language: "cs",
  phoneNumber: "+43 660 142 8800",
  companyId: DEMO_COMPANY_HOLDINGS_AG,
  companyName: "Contoso Holdings AG",
};

export const demoMsalAccount: AccountInfo = {
  homeAccountId: `${DEMO_USER.localAccountId}.demo-tenant`,
  environment: "demo.b2clogin.local",
  tenantId: "demo-tenant",
  username: DEMO_USER.username,
  localAccountId: DEMO_USER.localAccountId,
  name: DEMO_USER.fullName,
  idTokenClaims: {
    sub: DEMO_USER.localAccountId,
    userName: DEMO_USER.username,
    emails: [DEMO_USER.username],
    given_name: DEMO_USER.firstName,
    surname: DEMO_USER.lastName,
    phone: DEMO_USER.phoneNumber,
    lang: DEMO_USER.language,
    consents: undefined,
    sourceCompanyId: DEMO_USER.companyId,
  },
};
